'use client';

import { Button, cn } from '@baseball-near-you/ui';
import localFont from 'next/font/local';
import Link from 'next/link';
import { useEffect } from 'react';
import './globals.css';
import posthog from 'posthog-js';

const geistSans = localFont({
  src: [
    {
      path: './fonts/geist-sans/Geist-Medium.woff2',
      weight: '500',
      style: 'normal',
    },
    {
      path: './fonts/geist-sans/Geist-SemiBold.woff2',
      weight: '600',
      style: 'normal',
    },
  ],
  variable: '--font-geist-sans',
  fallback: [
    'ui-sans-serif',
    'system-ui',
    '-apple-system',
    'BlinkMacSystemFont',
  ],
});

export default function GlobalError({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  useEffect(() => {
    posthog.captureException(error, {
      global_error: true,
    });
  }, [error]);
  return (
    <html>
      <body className={cn(geistSans.variable, 'font-geist')}>
        <div className="flex h-screen w-full items-center justify-center bg-white font-sans">
          <div className="flex flex-col rounded-md bg-red p-24 text-white">
            <div className="flex flex-col">
              <p className="mb-2 font-semibold text-4xl">Page not found...</p>
              <p className="font-medium text-sm">
                An unexpected error has occurred.
              </p>
            </div>
            <Link href={'/'} className="mt-8 self-end">
              <Button className="not-italic! font-sans!" variant={'secondary'}>
                Go home
              </Button>
            </Link>
          </div>
        </div>
      </body>
    </html>
  );
}
